var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Info',{attrs:{"userInfo":_vm.userInfo}}),_c('TabTitle',{attrs:{"title":"邀请记录","isShowTips":false}},[(_vm.tabList.length)?_c('Table',{attrs:{"obj":_vm.tabList[0].data},on:{"sizeChange":_vm.sizeChange,"pageChange":_vm.pageChange}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }